<div class="container">
    <div class="controls">
        <form [formGroup]="form">
            <mat-form-field appearance="outline">
                <mat-label>Intervalo de datas</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matInput matStartDate formControlName="dateStart">
                    <input matInput matEndDate formControlName="dateEnd">
                </mat-date-range-input>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            </mat-form-field>
        </form>
    </div>

    <ng-container *ngIf="submiting">
        <mat-progress-spinner mode="indeterminate" diameter="40"> </mat-progress-spinner>
    </ng-container>
    <ng-container *ngIf="submiting == false">

        <ng-container *ngIf="datasource.data == null">
            <div class="empty-content" style="width: 100%">
                Resultado do filtro aparecerá aqui
            </div>
        </ng-container>

        <ng-container *ngIf="datasource.data && datasource.data.length == 0">
            <div class="empty-content" style="width: 100%">
                Nenhum resultado encontrado!
            </div>
        </ng-container>
        <ng-container *ngIf="datasource.data && datasource.data.length > 0">
            <div class="table-container" style="width: 50%">
                <table class="table" mat-table [dataSource]="datasource">
                    <ng-container *ngFor="let attr of displayedColumns">
                        <ng-container [matColumnDef]="attr">
                            <th mat-header-cell *matHeaderCellDef>
                                <span class="th-wrapper">
                                    {{ columnsDisplayName[attr] }}
                                </span>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element[attr] }}
                            </td>
                        </ng-container>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer"></tr>
                </table>

            </div>
        </ng-container>
    </ng-container>
</div>